'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Pillar(hue, icon, number, title, text, link) {
  this.jV = null;
  this.hF = null;
  this.hH = null;
  this.hJ = null;
  this.hI = null;
  this.hG = null;
  this.jV = hue;
  this.hF = icon;
  this.hH = number;
  this.hJ = title;
  this.hI = text;
  this.hG = link;
}
export { $c_Lio_intela_sites_intelacloud_content_Pillar as $c_Lio_intela_sites_intelacloud_content_Pillar };
$p = $c_Lio_intela_sites_intelacloud_content_Pillar.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Pillar;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Pillar() {
}
export { $h_Lio_intela_sites_intelacloud_content_Pillar as $h_Lio_intela_sites_intelacloud_content_Pillar };
$h_Lio_intela_sites_intelacloud_content_Pillar.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 704422918, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Pillar)) {
    var x = this.jV;
    var x$2 = x$0.jV;
    if ((x === x$2)) {
      var x$3 = this.hF;
      var x$4 = x$0.hF;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if (((($x_1 && (this.hH === x$0.hH)) && (this.hJ === x$0.hJ)) && (this.hI === x$0.hI))) {
      var x$5 = this.hG;
      var x$6 = x$0.hG;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 6;
});
$p.I = (function() {
  return "Pillar";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.jV;
      break;
    }
    case 1: {
      return this.hF;
      break;
    }
    case 2: {
      return this.hH;
      break;
    }
    case 3: {
      return this.hJ;
      break;
    }
    case 4: {
      return this.hI;
      break;
    }
    case 5: {
      return this.hG;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Pillar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bC)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Pillar as $isArrayOf_Lio_intela_sites_intelacloud_content_Pillar };
var $d_Lio_intela_sites_intelacloud_content_Pillar = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Pillar, "io.intela.sites.intelacloud.content.Pillar", ({
  bC: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Pillar as $d_Lio_intela_sites_intelacloud_content_Pillar };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Pillar.js.map
